
import React, { PropTypes } from 'react';

import './style.scss';
import { QuestionShape } from 'entities';

const ChatFeedbackQuestion = props => {
  const name = props.question.id;

  function handleLabelClick(answerId, answerValue) {
    props.onAnswer(props.question, answerId, answerValue);
  }

  return (
    <div className="ChatFeedbackQuestion">
      <h5>{props.question.text}</h5>

      <div className="choose row align-justify">
        {props.question.options.map((option) => {
          return (
            <div key={props.question.id + '_' + option.id} className="column option">
              <input
              type="radio"
              name={name}
              id={`${name}-${option.id}`}
              value={option.value}
              checked={props.question.answer === option.id}
              onChange={() => {}} />

              <label className="answer" htmlFor={name} onClick={() => handleLabelClick(option.id, option.value)}>{option.text}</label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

ChatFeedbackQuestion.propTypes = {
  question: QuestionShape,
  onAnswer: PropTypes.func
};

export default ChatFeedbackQuestion;



/** WEBPACK FOOTER **
 ** ./src/members/Main/ChatWindow/ChatFeedback/ChatFeedbackQuestion/index.js
 **/